import {Engine} from "platform/engine/Engine";
import Platform from "platform/Platform";
import Utils from "platform/util/Utils";
import CoreEngine from "platform/engine/CoreEngine";
import {LoadLanguagePayload, SetSupportedLanguages} from "platform/redux/translation/TranslationActions";
import {Configuration} from "core/configuration/Configuration";
import {InitChat, SetAppReadyPayload, SetUrls} from "platform/redux/core/CoreActions";
import {HttpReject} from "platform/network/http/Http";
import {AvailableLanguage, LoginConfigurationResponse} from "protocol/response/LoginConfigurationResponse";
import {LangCode} from "platform/enum/LangCode";
import {XhrManager} from "core/engine/XhrManager";
import {AppState} from "core/state/AppState";
import {ServiceType} from "enum/ServiceType";
import {LoginConfigurationRequest} from "protocol/request/LoginConfigurationRequest";
import WebUtil from "platform/util/WebUtil";
import {UrlType} from "platform/enum/UrlType";

export default class AppEngine extends Engine {

    private static _instance: AppEngine;

    public static instance(): AppEngine {
        return this._instance || (this._instance = new this());
    }

    public async setup(): Promise<void> {
        await super.setup();
        CoreEngine.instance().setup().catch(() => {});
    }

    public onAppReady = ({ready}: SetAppReadyPayload): void => {
    }

    public onLoadLanguage = async (payload: LoadLanguagePayload) => {
        const BrandId: number = Platform.config<Configuration>().brandId;
        this._logger.debug("Fetching config for lang: " + payload.langCode);
        const request: LoginConfigurationRequest = {BrandId, LanguageCode: payload.langCode};
        const answer: [HttpReject, LoginConfigurationResponse] = await Utils.to(XhrManager.sendToLogin(request, "LoginConfiguration"));
        if (answer[0]) {
            this._logger.debug("Failed fetch configuration: " + answer[0]);
        } else {
            const response: LoginConfigurationResponse = answer[1];
            if (response.SuccessStatus) {
                this._logger.debug("Config received.");
                Platform.dispatch(SetUrls({
                    urls: [
                        {type: UrlType.NewLogin, url: decodeURIComponent(response.NewLoginUrl)}
                    ]
                }));
                const appState: AppState = Platform.state<AppState>(ServiceType.App)
                const languages: LangCode[] = [];
                response.AvailableLanguageConfigurations.forEach((langConfig: AvailableLanguage) => {
                    const langCode: LangCode = LangCode[langConfig.Code.toUpperCase()];
                    if (Utils.isNotNull(langCode) && langConfig.IsActive && Platform.config<Configuration>().supportedLanguages.indexOf(langCode) > -1) {
                        appState.addLanguage(langCode, langConfig);
                        languages.push(langCode);
                    }
                });
                Platform.dispatch(SetSupportedLanguages({languages}));
                if (response.ChatUrl && !WebUtil.isFrame() && !WebUtil.inWebView()) {
                    Platform.dispatch(InitChat({scriptUrl: response.ChatUrl}));
                }
            } else {
                this._logger.debug("Failed fetch config: " + response.LocalizedErrorMessage);
            }
        }
    }

    public closeMe = (): void => {
        this._logger.debug("Asking to cloe me");
        if (WebUtil.inIosWebView()) {
            (window as any).webkit.messageHandlers.jsHandle.postMessage("closeWebView");
        } else if (WebUtil.inAndroidWebView()) {
            (window as any).MobileJsInterface.closeWebView();
        } else if (WebUtil.parentWindow()) {
            WebUtil.parentWindow().postMessage(JSON.stringify({operation: "closeGeneralWindow"}), "*");
        }
    }
}
